import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authAPI } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await authAPI.login(form);
      login(res.data.token, res.data.user);
      toast.success('مرحباً بعودتك! 👋');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'بيانات غير صحيحة');
    } finally { setLoading(false); }
  };

  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#0D1421',padding:20}}>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',maxWidth:900,width:'100%',borderRadius:24,overflow:'hidden',boxShadow:'0 25px 60px rgba(0,0,0,0.5)'}}>
        {/* Left Side */}
        <div style={{background:'linear-gradient(135deg,#0a2a4a 0%,#0D1421 100%)',padding:48,display:'flex',flexDirection:'column',justifyContent:'space-between',position:'relative',overflow:'hidden'}}>
          <div style={{position:'absolute',top:-50,right:-50,width:200,height:200,borderRadius:'50%',background:'rgba(0,212,255,0.08)'}} />
          <div style={{position:'absolute',bottom:-30,left:-30,width:150,height:150,borderRadius:'50%',background:'rgba(255,107,53,0.08)'}} />
          <div>
            <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:40}}>
              <span style={{fontSize:24}}>⚡</span>
              <span style={{fontSize:22,fontWeight:800,color:'var(--color-primary)'}}>SPORTIX</span>
            </div>
            <h2 style={{fontSize:28,fontWeight:800,marginBottom:12,lineHeight:1.4}}>مرحباً بعودتك إلى منصة التوظيف الرياضي</h2>
            <p style={{color:'var(--color-text-muted)',lineHeight:1.8,fontSize:14}}>سجّل دخولك للوصول إلى آلاف الفرص الرياضية والتواصل مع أفضل الأندية والمؤسسات.</p>
          </div>
          <div style={{display:'flex',flexDirection:'column',gap:16}}>
            {['🏆 آلاف الوظائف الرياضية','🤝 تواصل مع أفضل الأندية','⚡ خدمات رياضية احترافية'].map((t,i)=>(
              <div key={i} style={{display:'flex',alignItems:'center',gap:10,fontSize:13,color:'var(--color-text-muted)'}}>
                <span>{t}</span>
              </div>
            ))}
          </div>
        </div>
        {/* Right Side */}
        <div style={{background:'#131e2e',padding:48}}>
          <h3 style={{fontSize:24,fontWeight:700,marginBottom:6}}>تسجيل الدخول</h3>
          <p style={{color:'var(--color-text-muted)',fontSize:13,marginBottom:32}}>أدخل بياناتك للمتابعة</p>
          <form onSubmit={handleSubmit}>
            <div className="form-group" style={{marginBottom:16}}>
              <label className="form-label">البريد الإلكتروني</label>
              <input type="email" className="form-input" placeholder="example@email.com" value={form.email} onChange={e=>setForm(p=>({...p,email:e.target.value}))} required />
            </div>
            <div className="form-group" style={{marginBottom:24}}>
              <label className="form-label">كلمة المرور</label>
              <input type="password" className="form-input" placeholder="••••••••" value={form.password} onChange={e=>setForm(p=>({...p,password:e.target.value}))} required />
            </div>
            <button type="submit" className="btn btn-primary" style={{width:'100%',padding:'14px',fontSize:16,borderRadius:12}} disabled={loading}>
              {loading ? '⏳ جاري الدخول...' : 'دخول ←'}
            </button>
          </form>
          <div style={{margin:'24px 0',display:'flex',alignItems:'center',gap:12}}>
            <div style={{flex:1,height:1,background:'rgba(255,255,255,0.08)'}} />
            <span style={{color:'var(--color-text-muted)',fontSize:12}}>أو</span>
            <div style={{flex:1,height:1,background:'rgba(255,255,255,0.08)'}} />
          </div>
          <button style={{width:'100%',padding:'13px',borderRadius:12,background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.12)',color:'white',fontSize:14,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:10}}>
            <span style={{fontSize:18}}>🌐</span> تسجيل الدخول بـ Google
          </button>
          <p style={{textAlign:'center',marginTop:24,fontSize:13,color:'var(--color-text-muted)'}}>
            ليس لديك حساب؟ <Link to="/auth/register" style={{color:'var(--color-primary)',fontWeight:600}}>سجّل الآن مجاناً</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export const RegisterPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ full_name:'', email:'', password:'', user_type:'individual' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await authAPI.register(form);
      login(res.data.token, res.data.user);
      toast.success('أهلاً بك في SPORTIX! 🎉');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'حدث خطأ في التسجيل');
    } finally { setLoading(false); }
  };

  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#0D1421',padding:20}}>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',maxWidth:900,width:'100%',borderRadius:24,overflow:'hidden',boxShadow:'0 25px 60px rgba(0,0,0,0.5)'}}>
        {/* Left Side */}
        <div style={{background:'linear-gradient(135deg,#0a2a4a 0%,#0D1421 100%)',padding:48,display:'flex',flexDirection:'column',justifyContent:'space-between',position:'relative',overflow:'hidden'}}>
          <div style={{position:'absolute',top:-50,right:-50,width:200,height:200,borderRadius:'50%',background:'rgba(0,212,255,0.08)'}} />
          <div>
            <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:40}}>
              <span style={{fontSize:24}}>⚡</span>
              <span style={{fontSize:22,fontWeight:800,color:'var(--color-primary)'}}>SPORTIX</span>
            </div>
            <h2 style={{fontSize:28,fontWeight:800,marginBottom:12,lineHeight:1.4}}>انضم لأكبر منصة توظيف رياضي في المنطقة</h2>
            <p style={{color:'var(--color-text-muted)',lineHeight:1.8,fontSize:14}}>سواء كنت محترفاً رياضياً أو مؤسسة تبحث عن كفاءات، SPORTIX هو المكان المناسب لك.</p>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginTop:32}}>
            {[{n:'500+',l:'وظيفة متاحة'},{n:'200+',l:'مؤسسة رياضية'},{n:'1000+',l:'محترف رياضي'},{n:'100+',l:'خدمة متخصصة'}].map((s,i)=>(
              <div key={i} style={{background:'rgba(0,212,255,0.08)',borderRadius:12,padding:'16px',textAlign:'center'}}>
                <div style={{fontSize:20,fontWeight:800,color:'var(--color-primary)'}}>{s.n}</div>
                <div style={{fontSize:11,color:'var(--color-text-muted)',marginTop:4}}>{s.l}</div>
              </div>
            ))}
          </div>
        </div>
        {/* Right Side */}
        <div style={{background:'#131e2e',padding:48}}>
          <h3 style={{fontSize:24,fontWeight:700,marginBottom:6}}>إنشاء حساب جديد</h3>
          <p style={{color:'var(--color-text-muted)',fontSize:13,marginBottom:24}}>انضم مجاناً وابدأ رحلتك الرياضية</p>
          {/* Account Type */}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:20}}>
            {[{v:'individual',l:'🏃 محترف رياضي',d:'لاعب أو مدرب'},{v:'organization',l:'🏆 مؤسسة رياضية',d:'نادي أو أكاديمية'}].map(t=>(
              <div key={t.v} onClick={()=>setForm(p=>({...p,user_type:t.v}))} style={{padding:'12px',borderRadius:12,border:`2px solid ${form.user_type===t.v?'var(--color-primary)':'rgba(255,255,255,0.1)'}`,cursor:'pointer',background:form.user_type===t.v?'rgba(0,212,255,0.08)':'transparent',transition:'all 0.2s'}}>
                <div style={{fontWeight:600,fontSize:13}}>{t.l}</div>
                <div style={{fontSize:11,color:'var(--color-text-muted)',marginTop:2}}>{t.d}</div>
              </div>
            ))}
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form-group" style={{marginBottom:12}}>
              <label className="form-label">الاسم الكامل</label>
              <input type="text" className="form-input" placeholder="أدخل اسمك الكامل" value={form.full_name} onChange={e=>setForm(p=>({...p,full_name:e.target.value}))} required />
            </div>
            <div className="form-group" style={{marginBottom:12}}>
              <label className="form-label">البريد الإلكتروني</label>
              <input type="email" className="form-input" placeholder="example@email.com" value={form.email} onChange={e=>setForm(p=>({...p,email:e.target.value}))} required />
            </div>
            <div className="form-group" style={{marginBottom:20}}>
              <label className="form-label">كلمة المرور</label>
              <input type="password" className="form-input" placeholder="8 أحرف على الأقل" value={form.password} onChange={e=>setForm(p=>({...p,password:e.target.value}))} required minLength={8} />
            </div>
            <button type="submit" className="btn btn-primary" style={{width:'100%',padding:'14px',fontSize:16,borderRadius:12}} disabled={loading}>
              {loading ? '⏳ جاري التسجيل...' : 'إنشاء الحساب 🎉'}
            </button>
          </form>
          <div style={{margin:'20px 0',display:'flex',alignItems:'center',gap:12}}>
            <div style={{flex:1,height:1,background:'rgba(255,255,255,0.08)'}} />
            <span style={{color:'var(--color-text-muted)',fontSize:12}}>أو</span>
            <div style={{flex:1,height:1,background:'rgba(255,255,255,0.08)'}} />
          </div>
          <button style={{width:'100%',padding:'13px',borderRadius:12,background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.12)',color:'white',fontSize:14,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:10}}>
            <span style={{fontSize:18}}>🌐</span> التسجيل بـ Google
          </button>
          <p style={{textAlign:'center',marginTop:20,fontSize:13,color:'var(--color-text-muted)'}}>
            لديك حساب بالفعل؟ <Link to="/auth/login" style={{color:'var(--color-primary)',fontWeight:600}}>تسجيل الدخول</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default function Auth({ mode }) {
  return mode === 'register' ? <RegisterPage /> : <LoginPage />;
}
